$(document).ready(function(){
    /* GLOBALS */
    var autoSlide = true;

    /*
    // Bottom to top smooth scroll
    // Should be able to utilize this for sticky nav in page scrolling as well
    // And could even adapt this to function with horizontal scrolling
    */
    var smoothScroll = function() {
        $('body').on('click', 'a[href*="#"]', function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
                && 
                location.hostname == this.hostname
            ) {
                this.focus();
                var target = $(this.hash);

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 60
                    }, 1000, function() {});
                }
            }
        });
    }

    var homepageSliderClickTransition = function() {
        $('.slide-nav').click(function(){
            autoSlide = false; // Deactiavte Auto Transition

            // check if clicked on same slide
            var activeNav = $('.slide-nav.active');
            var active = $('.homepage-slide.active');
            var toBeActive = $('#slide-'+$(this).data('id'));

            // If user clicks on toggle for slide that is already showing
            if(toBeActive.attr('id') == active.attr('id')) {
                return;
            }
            
            $('#slide-'+$(this).data('id')).toggleClass('active',true);
            $(this).toggleClass('active', true);
            active.toggleClass('active',false);
            activeNav.toggleClass('active',false);
        })
    }

    var homepageSliderTimedTransition = function(currentSlide, nextSlide) {
        var totalSlides = $('.slide-nav');

        if(totalSlides.length > 1) {
            if (autoSlide) {
                setTimeout(function(){

                    $('#slide-'+currentSlide).toggleClass('active',false);
                    $('#slide-nav-'+currentSlide).toggleClass('active',false);
                    $('#slide-'+nextSlide).toggleClass('active',true);
                    $('#slide-nav-'+nextSlide).toggleClass('active',true);
                    currentSlide = nextSlide;

                    if ( nextSlide == totalSlides.length) {
                        nextSlide = 1
                    }
                    else {
                        nextSlide ++;
                    }
                    
                    homepageSliderTimedTransition(currentSlide, nextSlide);

                }, 4000);
            }
        }
    }

    /* Hamburger Toggle */
    var mainNavHamburger = function() {
        $('#nav-icon3').click(function() {
            $(this).toggleClass('open');
            $('#site-navigation').toggleClass('open');
            $('body').toggleClass('menu-open');
        });
    }

    /* Adding Custom Placeholder Text for Search */
    var customSearchPlaceholder = function() {
        $('.search-form .search-field').each(function() {
            $(this).attr("placeholder", "Search");
        });
    }

    /* Mobile communities nav toggle (header nav) */
    var headerCommunitiesMobileToggle = function() {
        $('#community-nav-toggle').click(function(){
            if ( $(window).width() <= 899 ) {
                $('#community-types').toggleClass('open');
                $(this).toggleClass('open');
            }
        });
    }

    /* General Expander/Dropdown function */
    var standardDropdownToggle = function() {
        $('.dropdown-toggle').each(function(){
            $(this).click(function(){
                $(this).parent('.dropdown-target').toggleClass('open');
            });
        });
    }

    /* Chapter In Page Navigation */
    var slidePrevious = function(){   
        $currentPercentage =  0;

        $('#slide-prev').click(function() {
            $sliderWidth = $('#sibling-menu').width();
            $currentPosition = parseInt($('#sibling-menu').css('margin-left'));

            if ($currentPosition < 0) { 
                // Mobile
                $('#slide-next').toggleClass('deactivated', false); 
                if ( $(window).width() <= 899 ) {   
                    $currentPercentage = $currentPercentage + 100;
                    $('#sibling-menu').css('margin-left',$currentPercentage+'%');

                    if($currentPercentage >= 0) {
                        $('#slide-prev').toggleClass('deactivated', true);
                    }
                }
                else {
                    $currentPercentage = $currentPercentage + 100;
                    $('#sibling-menu').css('margin-left',$currentPercentage+'%');

                    if($currentPercentage >= 0) {
                        $('#slide-prev').toggleClass('deactivated', true);
                    }
                }
            }
        });
    }

    var slideNext = function(){  
        $siblings = $('#sibling-menu').data('siblings');
        $maxWidthPercentage = $siblings * 100;
        $currentPercentage =  0;

        $('#slide-next').click(function() {
            $sliderWidth = $('#sibling-menu').width();
            $currentPosition = parseInt($('#sibling-menu').css('margin-left'));

            if ($currentPercentage > (($maxWidthPercentage-100) * -1)) {
                $('#slide-prev').toggleClass('deactivated', false);    
                if ( $(window).width() <= 899 ) {
                    $currentPercentage = $currentPercentage - 100;
                    $('#sibling-menu').css('margin-left',$currentPercentage+'%');

                    if ($currentPercentage <= (($maxWidthPercentage-100) * -1) ) {
                        $('#slide-next').toggleClass('deactivated', true);
                    }
                }
                else {  
                    if ($currentPercentage > (( ($maxWidthPercentage/2) -100) * -1)) {
                        $currentPercentage = $currentPercentage - 100;
                        $('#sibling-menu').css('margin-left',$currentPercentage+'%');

                        if ($currentPercentage <= ((($maxWidthPercentage/2) -100) * -1) ) {
                            $('#slide-next').toggleClass('deactivated', true);
                        }
                    }
                }
            }
        });
    }

    var printPage = function() {
        $('#click-to-print').on('click', function() {
            window.print();
        });
    }

    // Listening to the Nation video toggle


    var videoToggle = function () {
        var initialVideoTitle = $('.video-selector .titles > div:first-of-type');
        initialVideoTitle.addClass('selected');
        var videoId = initialVideoTitle.attr('data-id');

        $('.video-viewer .video[data-id="' + videoId + '"]').addClass('selected');


        if ($('.video-selector .mobile-titles').css('display') === 'none') {
            // if on desktop
            $('.video-selector .video-title').click (function (e) {
                var target = $(this);
                switchVideos(target.attr('data-id'));
            })
        } else {
            // if on mobile
            $('.video-selector select').on('change', mobileVideo);
        }
    }

    var mobileVideo = function () {
        var videoId = $(this).find('option[value="' + $(this).val() + '"]').attr('data-id');
        switchVideos(videoId);
    }

    var switchVideos = function (videoId) {
        // change selected title on desktop
        $('.video-selector .video-title.selected').removeClass('selected');
        $('.video-selector .video-title[data-id="' + videoId + '"]').addClass('selected');

        // change selected title in mobile dropdown
        var videoTitle = $('.video-selector .video-title[data-id="' + videoId + '"]')[0].innerText.toLowerCase();
        $('.video-selector select').val(videoTitle);
        // unbind change listener so it doesn't rerun on the next line when we force change
        $('.video-selector select').unbind('change');

        // then rebind, so it runs next time
        $('.video-selector select').on('change', mobileVideo);

        // finally, change video
        $('.video-viewer .video.selected').removeClass('selected');
        $('.video-viewer .video[data-id="' + videoId + '"]').addClass('selected');
    }


    var init = function () {
        mainNavHamburger();
        standardDropdownToggle(); 
        headerCommunitiesMobileToggle();  
        smoothScroll();
        homepageSliderClickTransition();
        homepageSliderTimedTransition(1, 2);
        slidePrevious();
        slideNext();
        customSearchPlaceholder();
        printPage();
        videoToggle();
    }



    init();
});
